import { render, staticRenderFns } from "./PlaceFull.vue?vue&type=template&id=17b0ccae&"
import script from "./PlaceFull.vue?vue&type=script&lang=js&"
export * from "./PlaceFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports